import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChainlockPencilSkirt = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.ChainlockPencilSkirt.itemName}
      name={SS23.pants.ChainlockPencilSkirt.itemName}
      price={SS23.pants.ChainlockPencilSkirt.itemPrice}
      fabric={SS23.pants.ChainlockPencilSkirt.itemFabric}
      src={SS23.pants.ChainlockPencilSkirt.sizeChart}
      divId={SS23.pants.ChainlockPencilSkirt.shopifyDivId}
      mainId={SS23.pants.ChainlockPencilSkirt.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.ChainlockPencilSkirt.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.ChainlockPencilSkirt.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChainlockPencilSkirt;
